export const isAuthenticated = (state) => {
  if (state.auth.auth.token) return true;
  return false;
};
export const selectAuthToken = (state) => state.auth.auth.token;
